// extracted by mini-css-extract-plugin
export default {"container":"_2HCrz","instruction":"_2wpNc","controlPopUp":"_1Yvj7","buttonContainer":"_12__a","next":"JVtni","skip":"_22xuf"};